import React, { useState } from 'react';
import { resetDocument, setDocument, useDocument } from '../../../../documents/editor/EditorContext';
import BaseSidebarPanel from './helpers/BaseSidebarPanel';
import NestedDragDropList from './helpers/inputs/NestedDragDropList';
export default function BlockOrderSidebarFields() {
    // Hook calls should be at the top level of the component, not inside functions
    const document = useDocument();
    console.log('Loaded Document:', document);
    function getBlockList(document, blockIds) {
        const blockList = [];
        blockIds.forEach(id => {
            if (!document[id])
                return;
            const blockType = document[id]['type'];
            const blockData = { id: id, content: blockType, children: null };
            if (blockType === 'ColumnsContainer') {
                blockData.children = document[id]['data']['props']['columns'].map((col, index) => ({
                    id: `${id}-col${index + 1}`,
                    content: `Column ${index + 1}`,
                    children: getBlockList(document, col['childrenIds']),
                }));
            }
            else if (blockType === 'Container') {
                blockData.children = getBlockList(document, document[id]['data']['props']['childrenIds']);
            }
            blockList.push(blockData);
        });
        return blockList;
    }
    // Usage
    const rootList = document['root']['data']['childrenIds'];
    const blockList = getBlockList(document, rootList);
    const [items, setItems] = useState(blockList);
    function rebuildBlocks(newOrder) {
        document['root']['data']['childrenIds'] = [];
        newOrder.forEach((block) => {
            document['root']['data']['childrenIds'].push(block.id);
            rebuildBlocksChildren(block.content, block.id, block.children);
        });
    }
    function rebuildBlocksChildren(content, id, children) {
        if (content == 'ColumnsContainer') {
            document[id]['data']['props']['columns'][0]['childrenIds'] = [];
            document[id]['data']['props']['columns'][1]['childrenIds'] = [];
            document[id]['data']['props']['columns'][2]['childrenIds'] = [];
            if (children.length >= 1 && children[0]['children'].length) {
                children[0]['children'].forEach((child) => {
                    document[id]['data']['props']['columns'][0]['childrenIds'].push(child.id);
                    rebuildBlocksChildren(child.content, child.id, child.children);
                });
            }
            if (children.length >= 2 && children[1]['children'].length) {
                children[1]['children'].forEach((child) => {
                    document[id]['data']['props']['columns'][1]['childrenIds'].push(child.id);
                    rebuildBlocksChildren(child.content, child.id, child.children);
                });
            }
            if (children.length >= 3 && children[2]['children'].length) {
                children[2]['children'].forEach((child) => {
                    document[id]['data']['props']['columns'][2]['childrenIds'].push(child.id);
                    rebuildBlocksChildren(child.content, child.id, child.children);
                });
            }
        }
        else if (content == 'Container') {
            document[id]['data']['props']['childrenIds'] = [];
            children.forEach((child) => {
                document[id]['data']['props']['childrenIds'].push(child.id);
                rebuildBlocksChildren(child.content, child.id, child.children);
            });
        }
    }
    const handleReorder = (updatedItems) => {
        setItems(updatedItems); // Updates the list in state
        console.log('New order:', updatedItems);
        rebuildBlocks(updatedItems);
        console.log('Updated Document:', document);
        resetDocument(document, 'block-order');
        setDocument(document);
    };
    return (React.createElement(BaseSidebarPanel, { title: "Block Order" },
        React.createElement(NestedDragDropList, { items: items, onChange: handleReorder })));
}
//# sourceMappingURL=BlockOrderSidebarPanel.js.map